import { useState, useCallback } from 'react';
import api from '../api/client';

const useGetListaURL = () => {
  const [isCargando, setCargando] = useState(false);
  const [erroresGetLista, setErroresGetLista] = useState(null);

  const fetchData = useCallback(async (path, usarDatos) => {
    setCargando(true);
    setErroresGetLista(null);
    try {
      const res = await api.get(path);

      if (res.ok) {
        // If data is null (204) return empty array
        usarDatos(res.data ?? []);
      } else {
        setErroresGetLista(res.errors ?? ['Error al cargar la lista']);
        usarDatos([]);
      }
    } catch (error) {
      console.error('Error GetLista', error.message ?? error);
      setErroresGetLista(['Error al cargar la lista']);
      usarDatos([]);
    }
    setCargando(false);
  }, []);

  const resetErroresGetLista = useCallback(() => {
    setErroresGetLista(null);
  }, []);

  return { isCargando, erroresGetLista, fetchData, resetErroresGetLista };
};

export default useGetListaURL;
